import {AfterViewChecked, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ColorEvent} from 'ngx-color';

/* color selector control */
@Component({
  selector: 'wx-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent implements OnInit, AfterViewChecked {
  @Input() disable?: boolean;
  @Input() classNames: string;
  @Input() colorPanelSize: number;
  @Input() color: string;
  @Output() onColorChanged = new EventEmitter<string>();
  @Output() onColorSelected = new EventEmitter<string>();
  popoverVisible: boolean;
  currentColor: string;
  style: any;

  constructor() {
    this.popoverVisible = false;
    this.colorPanelSize = 36;
  }

  visible: boolean = false;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
  }

  ngOnInit() {
    this.init();
  }

  ngAfterViewChecked() {
    this.init();
  }

  onColorChange(event: ColorEvent) {
    if (event.color.rgb) {
      const rgba = event.color.rgb;
      this.currentColor = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
      this.onColorChanged.next(this.currentColor);
      return;
    }

    if (event.color.hex) {
      this.currentColor = event.color.hex;
      this.onColorChanged.next(event.color.hex);
    }
  }

  onVisibleChange(visible: boolean) {
    if (visible === false) {
      this.onColorSelected.next(this.currentColor);
    }
  }

  init() {
    this.style = {
      'width': `${this.colorPanelSize}px`,
      'height': `${this.colorPanelSize}px`,
      'backgroundColor': this.color
    };
  }
}

